import styled from '@emotion/styled'

export const StyledScheduleContainer = styled('div')(({ theme }) => ({
  height: '840px',
  width: '100%',
  margin: '0 auto',
  // container
  '>div': {
    padding: 0,
    // wrapper
    '>div': {
      borderRadius: 0,
      // scrollbox
      '>div:nth-child(2)': {
        '&::-webkit-scrollbar': { height: 0 },
        '&::-webkit-scrollbar-thumb': {
          background: theme.scrollbarThumb,
        },
        '>:nth-child(1):empty': {
          width: '2px',
        },
      },
    },
  },
}))
